
// const DOMAIN = 'https://stgapp.ooredoo.com.kw';
// const IMAGEDOMAIN = 'https://stgapp.ooredoo.com.kw';

// const DOMAIN = 'https://premobapp.ooredoo.com.kw';
// const IMAGEDOMAIN = 'https://premobapp.ooredoo.com.kw';

// const DOMAIN = 'https://stgweb.ooredoo.com.kw';
// export const IMAGEDOMAIN = 'https://stgweb.ooredoo.com.kw';

// const DOMAIN = 'https://webpreprod.ooredoo.com.kw';
// export const IMAGEDOMAIN = 'https://webpreprod.ooredoo.com.kw';

const DOMAIN = 'https://www.ooredoo.com.kw';
export const IMAGEDOMAIN = 'https://www.ooredoo.com.kw';

const CTACCOUNTID = "4W5-Z66-475Z"; //"4W5-Z66-475Z";//"TEST-48Z-54W-675Z"; //preprod and STG
const GTMACCOUNTID ="GTM-53P5GK";//GTM-TT6HTZH --staging //GTM-53P5GK --prod 
const BuildPath = "/myooredoo"; //""
const BASE_URL = `${DOMAIN}/v6/api/`;
export const HE_DECRYPT_PASSWORD = process.env.REACT_APP_HE_DECRYPT_PASSWORD;
export const getAppImage = key => { 
  try {
    let _imgarr = key.split('/');
    let _img = _imgarr[_imgarr.length - 1];
    let _url = IMAGEDOMAIN + '/content/images/assets_mobapp/' + _img;
    return _url;
  } catch (e) { }
  return '';
};
const getApiEndpoint = url => {
  if (url?.includes('https:')) {
    return url;
  }
  let _url = BASE_URL + url;
  _url = _url.replace('/v6/api //v6/api/', '/v6/api/');
   _url = _url.replace('/v6/api/', '/webapis/api/');
  return _url;
};

export { BASE_URL, getApiEndpoint, DOMAIN, CTACCOUNTID, BuildPath, GTMACCOUNTID };

export const HOME_PAGE_URL_Sprint13 = {
  url: '/v6/api/pms/getpagemodules', //url: 'pms/getpagemodules',
  data: { name: 'rn_apphome_v3' },
};
export const PROMOTION_VIEW_ALL ={
  url: '/v6/api/pms/getpagemodules', //url: 'pms/getpagemodules',
  data: { name: 'rn_promotions_viewall'},
};
export const HOME_PAGE_URL = {
  url: '/v6/api/pms/getpagemodules', //url: 'pms/getpagemodules',
  data: { name: 'rn_apphome_v4' },
};

export const HOME_DASHBOARD_URL = {
  url: '/v6/api/mtx/dashboard', //url: 'pms/getpagemodules',
  data: { type: 'myservices' },
};

export const DGSERVICE_URL = {
  url: '/v6/api/pms/getpagemodules', //url: 'pms/getpagemodules',
  data: { name: 'rn_digitalservices_catglist_v3' },
};

export const DigitalServicesData = {
  url: '/v6/api/CategoryServices/GetServicesByCatName', //url: 'pms/getpagemodules',
  data: { servicegroup: 'vas', catname: '!DATA!' },
};

export const DigServiceDetails = {
  url: '/v6/api/CategoryServices/GetServiceDetailsBySName', //url: 'pms/getpagemodules',
  data: { servicegroup: 'vas', servicename: '!DATA!' },
};

export const ApiEndPoints = {
  template_2: {
    url: '/v6/api/commondata/GetData',
    data: {
      type: 'offersforyou',
      customertype: 'B2C',
      rateplantype: 'PREPAID',
      isdigitalcustomer: 'False',
      ishybrid: 'False',
      voiceline: 'True',
    },
  },
  template_3: {
    url: '/v6/api/ana/getanaplans',
    data: { type: 'buybundles' },
  },
  template_4: {
    url: '/v6/api/commondata/GetData',
    data: {
      type: 'roamingservices',
      customertype: '',
      rateplantype: '',
      isdigitalcustomer: 'false',
      ishybrid: 'false',
      voiceline: 'false',
    },
  },
  template_6: {
    url: '/v6/api/CategoryServices/GetServicesByCatName',
    data: { servicegroup: 'vas', catname: 'Best-Seller', bs: '0' },
  },
  template_7: {
    url: '/v6/api/subscription/discoveruseroffer',
    data: {
      ispromoincluded: 'true',
      sortfield: 'esm:price',
      sortorder: 'DESC',
      offercategory: 'ALL',
      offergroup: 'addons',
    },
  },
};

export const DigiserviceActivate = {
  url: '/v6/api/basicservices/activate', /// '/v6/api/basicservices/activate', //url: 'pms/getpagemodules',
  data: {
    msisdn: '',
    id: '',
    planid: '',
    servicenode: '',
    servicetype: '',
    type: 'vas',
  },
};
export const EndPointUserDetails = {
  url: '/v6/api/sso/rnuserdetails', /// '/v6/api/basicservices/activate', //url: 'pms/getpagemodules',
  data: {},
};

export const DASHBOARD_API = '/v6/api/mtx/dashboard';
export const PREPAIDBALANCE_API = '/v6/api/balance/prepaid';
export const POSTPAIDBALANCE_API = '/v6/api/billdetails/postpaid';
export const SUBSCRIPTION_API = '/v6/api/dbill/subscriberprofile';
export const LINEDETAILS_API = '/v6/api/subscription/linedetails';
export const FAVOURITE_API = '/v6/api/favourite';
export const LOGOUT_API = '/v6/api/authenticate/logout';
export const CANCELOFFER_API = '/v6/api/subscription/Rncanceloffer';
export const DEACTIVATE_SUBSCRIPTIONS_API = '/v6/api/basicservices/deactivate';
export const UPLOAD_IMAGEAPI = `${DOMAIN}/v6/api/upload/idcard`;
export const FAVOURITE_GET = '/v6/api/favourite/rngetfav';
export const FAVOURITE_SET = '/v6/api/favourite/rnsetfav';
export const ISSUE_TICKET_SUBMIT_API = '/v6/api/tt/rncreate';
export const ISSUE_TICKET_SUBMIT_NEW_API = '/v6/api/troubleticket/rncreate';
export const REQUEST_STATUS_API = '/v6/api/tt/getall';
export const UPLOAD_IMAGE_API = '/v6/api/upload/rnuploadimage';
export const UPDATE_NICKNAME_API = '/v6/api/sso/rnsetnickname';
export const GET_AVAILABLE_OFFERS_API = '/v6/api/mysuprise/getavailableoffers';
export const CUSTOMPRICE_API = '/v6/api/mysuprise/customprice';
export const PROVISION_API = '/v6/api/mysuprise/provision';
export const MyCOUNTRYPURCHASE_API = '/v6/api/subscription/Rnpurchaseoffer';
export const GET_DYNAMIC_CARDS_API = '/v6/api/pms/getdynamiccards';
export const GET_NOTICATIONS_API = 'notifications/pushinbox';
export const UPDATE_NOTICATIONS_STATUS = 'notifications/read';
export const ACTIVATE_SERVICE = 'basicservices/activate';
export const DEACTIVATE_SERVICE = 'basicservices/deactivate';
export const SCHEDULERENEWAL_API = 'subscription/Rnschedulerenewal';
export const TRANSFER_POINTS_API = 'nojoom/pointtransferps';
export const NOJOOM_HISTORY_API = 'nojoom/history';
export const NOJOOM_BUY_POINTS_API = 'nojoom/GetPointsValue';
export const INTERNATIONAL_COUNTRIES_API = '/pms/getinternationaltopups';
export const CHECK_ESIM_ELEGIBILTY = '/v6/api/esim/checkeligibility';
export const GET_SIMPROFILES = '/v6/api/esim/getsimprofiles';
export const CHANGE_TO_ESIM = '/v6/api/esim/changetoesim';
export const GET_LPA = '/v6/api/esim/getlpa';
export const VERIFY_TRANSFERCREDIT_PASST = '/v6/api/SSO/RnValidatepassword';
export const VERIFY_TRANSFERCREDIT_SOCIAL = '/v6/api/SSO/RnSocialauth';
export const BALANCE_TRANSFER_API = '/v6/api/balancetransfer/rntransfer';
export const CHANGE_PASST = '/v6/api/SSO/RnUpdatePassword';
export const RNPURCHASEOFFER = '/v6/api/subscription/rnpurchaseoffer';
export const RNCANCELOFFER = '/v6/api/subscription/rncanceloffer';
export const SAVE_RATING = '/v6/api/customerprofile/saverating';
export const PREPAIDRENEWALCONTROLAPI = '/v6/api/pms/getcurrentpack';

export const INTERNATIONAL_TRANSFER_API =
  '/v6/api/InternationalTopup/TransferTopup';
export const INTERNATIONAL_TOPUP_DENOMINATIONS_API =
  '/v6/api/InternationalTopup/GetDenominations';

export const AddonModelPopup = {
  url: '/v6/api/commonformtemplates/rnget',
  data: { type: 'ADDONBALANCE' },
};


export const BUNDLESHOME_URL = {
  url: '/v6/api/pms/getpagemodules', //url: 'pms/getpagemodules',
  data: { name: 'rn_bundles_home_v3' },
};

export const SPECIALDEALSHOME_URL = {
  url: '/v6/api/pms/getpagemodules', //url: 'pms/getpagemodules',
  data: { name: 'rn_specialdeals_v3' },
};

export const ADDONSHOME_URL = {
  url: '/v6/api/pms/getpagemodules', //url: 'pms/getpagemodules',
  data: { name: 'rn_addons_home_v3' },
};

export const SPINWIN_URL = {
  url: '/v6/api/pms/getpagemodules', //url: 'pms/getpagemodules',
  data: { name: 'rnspinwinstatus' },
};

export const NO_LINK_NUMBER = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_linknumber_v3' },
};

export const BUNDLESDETAILS_URL = {
  url: '/v6/api/subscription/discoveruserofffersV2', //url: 'pms/getpagemodules',
  data: { mode: 'rn_bundle_home_list' },
};

export const ADDONSDETAILS_URL = {
  url: '/v6/api/subscription/discoveruserofffersV2',
  data: { mode: 'RN_ADDON_HOME_LIST' },
};

export const SPECIALDEALSDETAILS_URL = {
  url: '/v6/api/subscription/discoveruserofffersV2',
  data: {
    offercategory: 'all',
    ispromoincluded: 'true',
    offertype: '',
    offergroup: 'BaseOffers',
    sortfield: 'esm:price',
    sortorder: 'DESC',
    packvalidity: '',
    crosssellingaddons: '',
    range: '',
    category: '',
    offerid: '',
    type: 'rnspecialdeals',
    customertype: '',
    rateplantype: '',
    isdigitalcustomer: 'false',
    ishybrid: 'false',
    voiceline: 'false',
  },
};

export const MYCOUNTRIESHOME_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_rom_mycountry_v3' },
};

export const MULTYCOUNTRYPASS = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_roaming_passport_list_v4' },
};
export const PASST_MULTI_COUNTRIES_URL = 'rn_roaming_passport_list_v4';
export const ROAMINGHOME_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_roaming_home_v4' },
};

export const PASSPORT_COUNTRIES_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_passport_countries_v3' },
};

export const PASSPORT_ROAMING_INT_RATES_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_rom_intl_rates_v3' },
};

export const PASSPORT_ROAMING_INT_RATES_LIST_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rom_intl_rates_list_v3' },
};

export const ROAMINGDEALS_LIST_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_roaming_deals_list_v3' },
};

export const OOREDOO_PASSPORT_LIST_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_roaming_passport_list_v3' },
};

export const ROAMING_OFFERS_URL = {
  url: '/v6/api/subscription/discoveruserofffersV2',
  data: {
    mode: 'RN_ooredoo_passport',
  },
};

export const OOREDOO_SURPRISE_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_oordoosuprise_v3' },
};

export const NOJOOMHOME_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_nozoom_home_v3' },
};

export const NOJOOMPARTNERREWARDS_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_nojommpartnerrewards' },
};

export const NOJOOM_DASHBOARD = {
  url: '/v6/api/nojoom/msisdndetailsps',
  data: {},
};

export const NOJOOM_PARTNERREWARDS = {
  url: '/v6/api/nojoom/queryloyaltypartnerproducts',
  data: {},
};

export const NOJOOM_RN_PARTNERREWARDS = {
  url: '/v6/api/nojoom/rnpartnerproducts',
  data: {},
};

export const NOJOOM_EARNPOINTSLIST = {
  url: '/v6/api/nojoom/querypartners',
  data: { type: 'earn' },
};

export const NOJOOM_TRANSFERTOPARTNER_LIST = {
  url: '/v6/api/nojoom/queryloyaltypartnerproducts',
  data: {},
};

export const NOJOOM_DONATE_POINTS = {
  url: '/v6/api/pms/settings',
  data: { id: '23' },
};
export const NOJOOM_ACTION_DONATEPOINTS = '/v6/api/nojoom/donate';

export const NOJOOM_LINKED_NUMBERS = {
  url: '/v6/api/nojoom/rngetlinkednumbers',
  data: {},
};

export const NOJOOM_SET_LINKED_NUMBERS = '/v6/api/nojoom/linknumbers';

export const NOJOOM_TRANSFER_TO_PARTNER =
  '/v6/api/nojoom/redemptiontransactionps';
export const NOJOOM_PARTNERLISTHOME_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'nozoom_partnerrewards_home_v3' },
};

export const NOJOOM_EARNPARTNERSHOME_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_nozoom_earnpartners_home_v3' },
};

export const NOJOOM_OOREDOOREWARDLISTHOME_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'nozoom_ooredooarewards_home_v3' },
};

export const NOJOOM_OOREDOOREWARD_ITEMLIST_URL = {
  url: '/v6/api/nojoom/telcoproducts',
  data: { category: '', tomsisdn: '', type: 'rn' },
};

export const NOJOOM_PARTNER_REDEEMPOINTS = {
  url: '/v6/api/nojoom/redemptiontransactionps',
  data: { type: '1', pname: '' },
};

export const GET_BASICSERVICES_LIST = {
  url: '/v6/api/basicservices/list',
  data: { msisdn: '', type: 'basic' },
};

export const BASIC_SERICES_ACTIVATE = '/v6/api/basicservices/activate';

export const BASIC_SERICES_DEACTIVATE = '/v6/api/basicservices/deactivate';

export const PUSH_NOTIFICATION_REGISTER =
  '/v6/api/pushnotification/pushregister';

export const PUSH_OOREDOOSERVICE_BUNDLE_PURCHASE =
  '/v6/api/nojoom/createredemption';

export const BUY_POINTS_KNET = '/v6/api/nojoom/RNBuyPointsUsingKnet';

export const BUY_POINTS_MPGS = '/v6/api/nojoom/RNBuyPointsUsingMpgs';
export const UPDATE_PROFILE_URL = '/v6/api/sso/RNUpdateProfile';

export const NOJOOM_ENROLL_SERVICE = '/v6/api/nojoom/enrollment';

export const PAGEMODULEAPI = '/v6/api/pms/getpagemodules';
export const MORE_HOME_GUEST_PAGE = 'rn_guest_more_v3';
export const MORE_HOME_GUEST_PAGE_V4 = 'rn_guest_more_v4';
export const PAY_HOME_GUEST_PAGE = 'rn_guest_pay_v3';
export const MORE_STACK_HOME_PAGE = 'rn_more_v3';
export const MORE_STACK_HOME_PAGE_V4 = 'rn_more_v4';
export const PAY_STACK_HOME_PAGE = 'rn_pay_v3';
export const NOJOOM_EARNPOINTSLIST_PAGE = 'rn_nozoom_earnpartners_home_v3';
export const MORE_ACCOUNTS_PAGE = 'rn_account_v3';
// export const CAPTCHA_URL = `${DOMAIN}/v6/content/captcha.aspx`;
export const CAPTCHA_URL = `${DOMAIN}/content/captcha.aspx`;
export const RN_SENDOTP_API = 'sso/rnsendotp';
export const RN_CHANGE_EMAIL_API = 'sso/rnchangeemail';
export const RN_REMOVE_SOCIAL_CONNECT_API = 'sso/rnremovesocialconnect';
export const NOJOOM_TRANSFERPOINTS_HOME = 'rn_nozoom_transferpoints_v3';
export const PAYVIAVOUCHER_RECHARGE = '/v6/api/voucher/rnrecharge';
export const SHOP_HOME_PAGE = 'rn_eshop_home_v3';
export const LINEDETAILS = 'rn_linedetails_v3';
export const SHOP_GUESTHOME_PAGE = 'rn_eshop_home_v3';
export const GET_COMPATIBLE_DEVICES = '/v6/api/esim/getcompatibledevices';
export const ESIM_SWAP_VALIDATE = '/v6/api/esim/esimswapvalidate';
export const BILL_PAY_RECHARGE_PLANS = {
  url: '/v6/api/pms/getvaliditydenominations',
  data: {},
};
export const BILL_PAY_NUMBERS = {
  url: '/v6/api/osb/getrnnumbers',
  data: {},
};
export const LANGUAGE_UPDATE = '/v6/api/language/update';
export const GET_VIEW_BILL = '/v6/api/billpdf/get';
export const GET_VIEW_BILL_DETAILS = '/v6/api/billdetails/RnGetbilldetails';
export const VALIDATE_TRANSFER =
  '/v6/api/balancetransfer/RnValidatebalancetransfer';

export const GET_NOTIFICATIONCARDS_LIST = {
  url: '/v6/api/sso/rnnotifications',
  data: { type: 'notifications' },
};
export const SMART_PAY_GET_STATUS = '/v6/api/smartpay/Getstatus';
export const SMART_PAY_GET_BANK = '/v6/api/pms/settings';
export const SMART_PAY_ENROLL = '/v6/api/smartpay/smartpayenroll';
export const SMART_PAY_DELETE_CARD = '/v6/api/smartpay/Delete';
export const PASST_AUTORENEWAL = '/v6/api/passport/autorenewal';
export const REQUEST_RECHARGE = '/v6/api/voucher/requestrecharge';
export const DONOR_SUMMARY = '/v6/api/share/donorsummary';
export const ADD_RECEIVER = '/v6/api/share/addreceiver';
export const SHARE_DATA = '/v6/api/share/sharedata';
export const AUTO_RENEW_RECURRENT = '/v6/api/share/recurrent';
export const REMOVE_ADDED_MEMBER = '/v6/api/share/remove';
export const MANAGELINES_ADD_NUMBER = 'osb/addnonaccountnumbers';
export const MANAGELINES_DELETE_NUMBER = 'osb/deletenonaccountnumbers';
export const GOVERNORATE = '/v6/api/pms/Rnmasterlovs';
export const ADD_ADDRESS = '/v6/api/ApiFeatures/RnInsertAddress';
export const GET_ADDRESS = '/v6/api/ApiFeatures/RnGetAddress';
export const DELETE_ADDRESS = '/v6/api/ApiFeatures/RnDeleteAddress';
export const UPDATE_ADDRESS = '/v6/api/ApiFeatures/RnUpdateAddress';
export const XPRESS_PROFIT = 'rn_xpressprofit_v3';
export const TRANSFER_BALANCE = 'rn_xpress_tbalance_v3';
export const LOAD_BALANCE = 'rn_xpress_loadbalance_v3';
export const ENQUIRY_ELIGIBILITY = 'balance/EnquiryEligibility';
export const XPRESS_TRANSFER_AMT = 'balance/XpressTransferAmount';
export const XPRESS_PAYMENT_OPTION = 'customerprofile/rjpaymentoptions';
export const USAGE_WIDGET = '/v6/api/mtx/dashboard';
export const PASST_WIDGET = '/v6/api/subscription/useroffers';
export const FOLLOWUP_API = '/v6/api/tt/rnttfollowup';
export const REMOVEPROFILE_IMAGE = '/v6/api/sso/rnremoveprofilepic';
export const NO_NUMBER_LINK = 'rn_linknumber_v3';
export const EsimQRCodeTooltip = {
  url: '/v6/api/commonformtemplates/rnget',
  data: { type: 'ESIMQRCODE' },
};
export const XPRESS_PROFIT_KNET_PAYMENT = '/v6/api/payment/xpressknetpay';
export const XPRESS_PROFIT_CREDIT_PAYMENT = '/v6/api/payment/xpressccpay';
export const XPRESS_PROFIT_PREPAID_BALANCE = '/v6/api/balance/xpressprepaid';
export const LOAD_BALANCE_VALIDATE_TRANSFER =
  '/v6/api/balancetransfer/rnvalidateloadtransfer';
export const REQUEST_RECHARGE_VALIDATE =
  '/v6/api/voucher/rnrequestrechargevalidate';
export const UPSELL5GDETAILS_URL = {
  url: '/v6/api/subscription/specialrecommendations',
  data: { recommendedtype: 'RECOMMEND', ishome: '!ISHOME!' },
};
export const UPSELL_DETAILS = 'rn_upsell_more_v3';
export const SPIN_WIN_CLAIM_API = '/v6/api/spinwin/claim';
export const GET_MANAGE_CARDS = '/v6/api/SSO/rngetcarddetails';
export const GET_SAVE_CARD_CUSTOMERID = '/v6/api/sso/rnsavecustomerid';
export const DELETE_CARD_API = '/v6/api/sso/rndeletecard';
export const JOURNEY_LOG_API = '/v6/api/journey/log';

export const FIFA_LEADERBOARD = 'rn_fifa_leaderboard_v4';
export const FIFA_WINNERSBOARD = '/v6/api/fifa/Winnerboard';
export const GET_FIFA_COUNTRIES = '/v6/api/fifa/getfifacountries';
export const GET_SELECTION_COUNT = '/v6/api/fifa/selectcountry';
export const SAVE_COUNTRY = '/v6/api/fifa/savecountry';
export const GET_POINT = '/v6/api/fifa/getPointsPrice';
export const BUY_POINT = 'rn_fifa_buypoints_v4';
export const FIFA_PAYMENT = 'paymentgw/fifarngetpaymentLink';
export const WATCHVIDEO = '/v6/api/pms/getdynamiccards';
export const INSTANT_EARN = '/v6/api/Fifa/InstantPurchase';
export const ACTIVATE_FREE_POINTS = '/v6/api/Fifa/ActiveFreePoints';
export const FIFA_GETEAMINFO = {
  url: '/v6/api/fifa/Getteaminfo',
  data: {},
};
export const FIFA_DASHBOARD = {
  url: '/v6/api/Fifa/GetDashboard', //url: 'pms/getpagemodules',
  data: {},
};
export const FIFA_BUY_POINT = '/v6/api/Fifa/fifabuypoints';
export const MOBILEID_STATUS = '/v6/api/TransferAuth/rnhasmobileid';
export const MOBILEID_AUTHENTICATION_STATUS =
  '/v6/api/postpaid/getauthenticationstatus';
export const MOBILEID_SAVEDETAILS = '/v6/api/TransferAuth/Savedetails';

export const LOGIN_SSO_URL = "/v6/api/sso/rnlogin";
export const QUERY_ACCOUNT = "/v6/api/osb/queryaccount";
export const SET_REMOVE_PRIMARY = "/v6/api/osb/UpdateAccount";
export const SPECIAL_DEALS_OFFER_ACTIVATE = "/v6/api/offers/activate";

export const OOREDOO_ASSIST_LIST = {
  url: '/v6/api/commonformtemplates/rnget',
  data: { type: 'OASSIST' },
};

export const PAYMENT_DETAILS = "/v6/api/paymenttrans/viewdetails";
export const PAYMENT_STATUS = "/v6/api/paymentgw/getstatus";

export const VERIFY_ACCOUNT = '/v6/api/sso/rnprofilesearch';

export const AUTHENTICATION_KUWAIT = {
  url: '/v6/api/TransferAuth/Checktwofactor',
  data: {mode: 'check'},
};

export const XPRESSPROFITHOME_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_xpressprofit_v3' },
};

export const LOAD_BALANCE_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_xpress_loadbalance_v3' },
};

export const TRANSFER_BALANCE_URL = {
  url: '/v6/api/pms/getpagemodules',
  data: { name: 'rn_xpress_tbalance_v3' },
};

export const SPECIALDEALS_VIEWALL_URL = {
    url: '/v6/api/pms/getpagemodules', //url: 'pms/getpagemodules',
    data: { name: 'rn_cvmdetails_v3' },
  };

export const MANAGE_ACCOUNT = {
    url: '/v6/api/pms/getpagemodules',
    data: { name: 'rn_linedetailsnew_v4' },
};

export const GET_BASICSERVICES = {
  url: '/v6/api/basicservices/list',
  data: { type: 'basic', skipsub: 'T' },
};
  
// smart-pay
export const SMART_PAY_MANGAE_SETTINGS = '/v6/api/pms/getdynamiccards';
export const SMART_PAY_OPTOUT = '/v6/api/rnsmartpay/optout';
export const SMART_PAY_GET_ACTIVE_CARDS = '/v6/api/rnsmartpay/carddetails';
export const SMART_PAY_MANAGE = '/v6/api/rnsmartpay/managesmartpay';
export const SMART_PAY_ENROLL_NUMBERS = '/v6/api/rnsmartpay/enrollnumbers';
export const SMART_PAY_EDIT_NUMBERS = '/v6/api/rnsmartpay/editnumbers';
export const SMART_PAY_MSISDN_UPDATE = '/v6/api/rnsmartpay/updatesmartmsisdn';
export const SMART_PAY_DELETE = '/v6/api/rnsmartpay/deletecard';
export const SMART_PAY_CARD_UPDATE = '/v6/api/rnsmartpay/updatesmartcard';
export const SMART_PAY_OPTIN = '/v6/api/rnsmartpay/optin';
export const SMART_PAY_ENROLL_OR_NOT_STATUS =
  '/v6/api/rnsmartpay/issmartpayenroll';
  export const SMART_PAY_STATUS =
  '/v6/api/rnsmartpay/status';
export const NEW_RENEWAL_PACK ='/v6/api/pms/getrenewalpackprice';

export const ISOFFERACTIVE_URL = {
  url: '/v6/api/subscription/isofferactive',
};

/**
 * CRD APIS
 */
export const CDR_SETTINGS = "/v6/api/cdr/settings";
export const CDR_VALIDATE_OTP = "/cdr/validateotp";
export const CDR_SEND_OTP = "/cdr/sendotp";
export const CDR_AUTH_STATUS = "paci/getauthenticationstatus";
export const CDR_HAS_MOBILEID = "paci/rnhasmobileid";
export const CDR_TandC = "/v6/api/eshop/GetSegmentDataListBySegmentId"
export const CDR_GET_DATA = "/v6/api/cdr/getcdrdata";
export const CDR_DO_TRANS = "/v6/api/cdr/dotrans";
export const CDR_GET_JSON = "/v6/api/cdr/getjson";
export const CDR_GET_PAYMENT_LINK = "/v6/api/cdr/GetPaymentLink";